import Vue from 'vue';

export const formatMoney = ( number, showSymbol = true, delimiter = "." ) => {
  if (number === null) return '';
  let parts = number.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0");
  let money = parts.join(delimiter);
  if (showSymbol) {
    money += '₽';
  }
  return money;
};

Vue.filter('money', formatMoney);
